import 'bootstrap/dist/css/bootstrap.min.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useLocation, useNavigate } from "react-router-dom";
import '../../App.scss';
import Campaign from './campaign/Campaign';
import Dashboard from './dashboard/Dashboard';
import Template from './template/Template';

export default function TabHome({ searchText, setSearchText, searchResults, setSearchResults, bulkText, setBulkText }) {

   const location = useLocation();
   const navigate = useNavigate();

   const currentPath = location.pathname;

   // Map tab keys to routes
   const handleSelect = (key) => {
      navigate(key);
   };

   return (
      <Tabs
         activeKey={currentPath}
         onSelect={handleSelect}
         justify
      >
         <Tab eventKey="/" title="Campaigns" style={{ marginTop: '1rem' }}>
            <Campaign
               searchText={searchText}
               setSearchText={setSearchText}
               searchResults={searchResults}
               setSearchResults={setSearchResults}
            />
         </Tab>
         <Tab eventKey="/templates" title="Templates" style={{ marginTop: '1rem' }}>
            <Template
               bulkText={bulkText}
               setBulkText={setBulkText}
            />
         </Tab>
      </Tabs>
   );
};
